import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AuthShell } from "@/pages/Login";

export default function ForgotPassword() {
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [sent, setSent] = useState(false);
    const [err, setErr] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setErr(""); setBusy(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (e2) {
            setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <AuthShell
            title={sent ? "Check your email" : "Forgot your password?"}
            subtitle={sent
                ? "If an account exists for that email, we just sent a reset link. It expires in 30 minutes."
                : "Enter the email you signed up with and we'll send a reset link."}
        >
            {sent ? (
                <div data-testid="forgot-success">
                    <p style={{ color: "var(--bm-text-muted)", fontSize: 14, margin: "0 0 18px" }}>
                        Didn't get it? Check your spam folder, or try again in a few minutes.
                    </p>
                    <button
                        data-testid="forgot-back-btn"
                        className="bm-btn bm-btn-ghost"
                        onClick={() => nav("/login")}
                        style={{ width: "100%" }}
                    >
                        Back to sign in
                    </button>
                </div>
            ) : (
                <form onSubmit={submit} data-testid="forgot-form">
                    <div style={{ marginBottom: 14 }}>
                        <label className="bm-label">Email</label>
                        <input
                            data-testid="forgot-email-input"
                            type="email"
                            className="bm-input"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            autoComplete="email"
                            required
                        />
                    </div>
                    {err && <div data-testid="forgot-error" style={{ marginBottom: 14, color: "var(--bm-bad)", fontSize: 13 }}>{err}</div>}
                    <button
                        data-testid="forgot-submit-btn"
                        type="submit"
                        disabled={busy}
                        className="bm-btn bm-btn-primary"
                        style={{ width: "100%", padding: "12px 16px", opacity: busy ? 0.6 : 1 }}
                    >
                        {busy ? "Sending…" : "Send reset link"}
                    </button>
                    <div style={{ marginTop: 18, textAlign: "center", color: "var(--bm-text-muted)", fontSize: 13 }}>
                        Remembered it?{" "}
                        <Link data-testid="forgot-to-login-link" className="bm-link" to="/login">Sign in</Link>
                    </div>
                </form>
            )}
        </AuthShell>
    );
}
